import { render, staticRenderFns } from "./case_list.vue?vue&type=template&id=5c48d434&scoped=true"
import script from "./case_list.vue?vue&type=script&lang=js"
export * from "./case_list.vue?vue&type=script&lang=js"
import style0 from "./case_list.vue?vue&type=style&index=0&id=5c48d434&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48d434",
  null
  
)

export default component.exports